(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-isabel"]) return;
  try {
    
(() => {
  document.querySelectorAll('.ir-header').forEach((header) => {
    if (header.dataset.mobileMenuReady === 'true') return;

    const toggle = header.querySelector('.ir-header__toggle');
    const menu = header.querySelector('.ir-header__mobile-nav');

    if (!toggle || !menu) return;

    header.dataset.mobileMenuReady = 'true';

    toggle.addEventListener('click', () => {
      const isOpen = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!isOpen));
      menu.hidden = isOpen;
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
